"use strict";

angular.module("app.elements.characteristics", [])
  .directive("viCharacteristics", function () {
    return {
      templateUrl: "app/js/modules/elements/characteristics/characteristics.html"
    };
  });
